module.exports = __webpack_public_path__ + "img/bdhyq-yndt.cedce0f2.jpg";